module.exports = __webpack_public_path__ + "img/palmas-resort-2.cc83873d.jpg";